/* eslint-disable @typescript-eslint/no-explicit-any --
 * ECharts does not publish types for the internals below; they are `any` by
 * necessity. Containing that here is the reason this module exists.
 */
import { EChartsInstance } from 'echarts-for-react';

type EChartsPrivate = {
    isDisposed?: () => boolean;
    _coordSysMgr?: { getCoordinateSystems?: () => unknown[] };
    _componentsViews?: any[];
    _chartsViews?: any[];
    _model?: { _componentsMap?: { data?: { get?: (mainType: string) => any[] } } };
    getModel?: () => { _componentsMap?: { data?: { get?: (mainType: string) => any[] } } };
};

const internals = (chartInstance: EChartsInstance): EChartsPrivate =>
    chartInstance as unknown as EChartsPrivate;

const isUsable = (chartInstance: EChartsInstance): boolean =>
    Boolean(chartInstance) && internals(chartInstance).isDisposed?.() !== true;

export function getCoordinateSystems(chartInstance: EChartsInstance): unknown[] {
    if (!isUsable(chartInstance)) return [];

    return internals(chartInstance)._coordSysMgr?.getCoordinateSystems?.() ?? [];
}

export function getComponentViews(chartInstance: EChartsInstance): any[] {
    if (!isUsable(chartInstance)) return [];

    return internals(chartInstance)._componentsViews ?? [];
}

export function getChartViews(chartInstance: EChartsInstance): any[] {
    if (!isUsable(chartInstance)) return [];

    return internals(chartInstance)._chartsViews ?? [];
}

export function getSeriesComponent(chartInstance: EChartsInstance): any {
    if (!isUsable(chartInstance)) return undefined;

    const instance = internals(chartInstance);
    const model = instance.getModel?.() ?? instance._model;

    return model?._componentsMap?.data?.get?.('series')?.[0];
}
